module.exports = __webpack_public_path__ + "img/prof2.01974500.jpg";